/**
 * @param {object} props
 * @param {string} props.title
 * @param {string} [props.detail]
 * @param {() => void} [props.onRetry]
 */
export default function ErrorView({ title, detail, onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center animate-fade-in">
      <div className="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center mb-5">
        <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
          <circle cx={12} cy={12} r={10}/>
          <path d="M12 8v4"/>
          <path d="M12 16h.01"/>
        </svg>
      </div>
      <h3 className="text-lg font-semibold mb-2 text-gray-900">{title}</h3>
      {detail && <p className="text-sm text-gray-500 max-w-md leading-relaxed mb-5">{detail}</p>}
      {onRetry && (
        <button type="button" className="btn-primary text-sm px-5 py-2.5" onClick={onRetry}>
          Повторить попытку
        </button>
      )}
    </div>
  );
}